import { createIcon } from './icon-utils';

export const TableBorderWeightIcon = createIcon({
  path: 'M3.5 5h17a.5.5 0 1 1 0 1h-17a.5.5 0 0 1 0-1zm.25 3.5h16.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zm.25 4h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm.5 4.5h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1 0-3z',
  viewBox: '0 0 24 24',
});
